export var BANK_INFORMATION_TRANSLATIONS = {
    bankInformation: {
        fields: {
            accountOwnerName: 'Nombre del titular de la cuenta',
            bankingEntity: 'Seleccione un banco',
            accountOwnerIdType: 'Tipo de identificación',
            accountOwnerId: 'Identidad del titular de la cuenta',
            accountType: 'Tipo de cuenta',
            accountDigit: 'Digito Verificador de Cuenta',
            agency: 'Agencia',
            verificationCode: 'Digito Verificador de Agencia',
            accountNumber: 'Número de cuenta',
            taxResidence: 'Domicilio fiscal',
            phonePrefix: 'Prefijo de país',
            phone: 'Teléfono de contacto',
            accountOwnerEmail: 'Correo electrónico de facturación',
            cci: 'CCI',
            paymentsAuthorization: 'Declaro y acepto que los pagos de la sucursal/marca sean realizado a la cuenta bancaria relacionada en la presente sección.',
            errors: {
                paymentsAuthorization: 'Debe aceptar los términos y condiciones',
            },
            tooltips: {
                bankingEntity: 'Los bancos que no están en la lista no son aceptados actualmente por Rappi',
                taxResidence: 'Ingresa la dirección de registro de la cuenta',
                phone: 'Ingresa el número de contacto del restaurante',
            },
        },
        information: {
            br: '<b>Atención al completar:</b> Para garantizar la correcta recepción de los pagos, observe las siguientes pautas: Solo aceptamos cuentas corrientes para el registro. Si usted es un Microempresario Individual (MEI), utilice su cuenta corriente personal (número CPF del representante legal). Las empresas que no sean MEI deberán presentar una cuenta corriente legal (CNPJ). Complete cuidadosamente para evitar errores que podrían retrasar sus pagos.',
        },
    },
};
